import React from 'react';
import { Tag } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { withAutoMetric } from '@beef/auto-metric';
import type { TagPropSize } from '@carnica/ui-kit/types';

import styles from './styles.pcss';
import { TLabel } from './types';

const cx = classNames.bind(styles);

type TNewsLabelsItemProps = {
  size?: TagPropSize;
} & TLabel;

const _NewsLabelsItem: React.FC<TNewsLabelsItemProps> = ({ isActive, title, size }) => (
  <Tag className={cx(isActive ? 'dark' : 'light')} size={size} view={isActive ? 'dark' : 'light'}>
    {title}
  </Tag>
);

export const NewsLabelsItem = withAutoMetric.Element((props: TNewsLabelsItemProps) => ({
  name: 'NewsLabelsItem',
  tag_text: props.title,
}))(_NewsLabelsItem);
